<groundworks-modal>
  <groundworks-modal-header
    [title]="isEditMode() ? 'Edit Special Needs' : 'Add Special Needs'"
    [isCancellable]="true"
    (cancelModal)="cancel()"
  />
  <groundworks-modal-body>
    <div class="mb-3">
      <label for="description" class="form-label">Description <span class="text-danger">*</span></label>
      <textarea
        id="description"
        class="form-control"
        rows="1"
        [disabled]="wasCompletedOnLoad()"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
        placeholder="Enter description of need."
      ></textarea>
    </div>
    <div class="mb-3">
      <label for="assignedTo" class="form-label">Assigned To <span class="text-danger">*</span></label>
      <ng-select
        inputId="assignedTo"
        [items]="users()"
        bindLabel="name"
        bindValue="id"
        placeholder="Please select"
        [loading]="isLoading()"
        [clearable]="true"
        [disabled]="wasCompletedOnLoad()"
        [ngModel]="assignedTo()"
        (ngModelChange)="assignedTo.set($event)">
      </ng-select>
    </div>
    <div class="mb-3">
      <label for="remindOn" class="form-label">Remind On <span class="text-danger">*</span></label>
      <div class="position-relative">
        <input
          id="remindOn"
          type="text"
          readonly
          class="form-control pe-4"
          [value]="formatDateForDisplay(dueDate())"
          placeholder="Select date"
          [disabled]="wasCompletedOnLoad()"
          [style.cursor]="wasCompletedOnLoad() ? 'not-allowed' : 'pointer'"
          (click)="!wasCompletedOnLoad() && toggleDatePicker()"
        />
        <button
          type="button"
          class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
          aria-label="Toggle date picker"
          [disabled]="wasCompletedOnLoad()"
          (click)="toggleDatePicker()"
        >
          <i class="bi bi-calendar-check"></i>
        </button>
        @if (showDatePicker()) {
        <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
          <groundworks-date-picker
            [isRangeSelection]="false"
            [displayMonths]="1"
            [selectedDate]="selectedDateAsDate()"
            (fromDateEvent)="handleDateSelected($event)"
          />
        </div>
        }
      </div>
    </div>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
